var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Layout',[_c('div',{staticClass:"home__page-center",attrs:{"slot":"center"},slot:"center"},[_c('p',[_vm._v("esc-ui")]),_c('p',[_vm._v("Vue + ts 实践业务组件库")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }